/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AgentIDForm = {
  /**
   * First-class agent identifier
   */
  agentId: string;
};

/** @internal */
export type AgentIDForm$Outbound = {
  agent_id: string;
};

/** @internal */
export const AgentIDForm$outboundSchema: z.ZodMiniType<
  AgentIDForm$Outbound,
  AgentIDForm
> = z.pipe(
  z.object({
    agentId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
    });
  }),
);

export function agentIDFormToJSON(agentIDForm: AgentIDForm): string {
  return JSON.stringify(AgentIDForm$outboundSchema.parse(agentIDForm));
}
